export const EXPERIENCE_BOOKING_TYPE = {
  buyNow: 'buy_now',
  onDemand: 'on_demand',
};
